import { observer } from 'mobx-react'
import WrapNativeForm from '../Lend/LendForm/WrapNativeForm'
import ToolsVM from './ToolsVM'
import { NavLink } from 'react-router-dom'
import { Icon } from 'ui-framework'
import React from 'react'

export function WrapNative({ vm }: { vm: ToolsVM }) {
  return (
    <section className="tools__container">
      <h2 className="title-page txt-center margin-bottom-2">Wrap or unwrap native token</h2>

      <div className="panel--simple md-padded-2">
        <WrapNativeForm form={vm.wrapNativeForm} />
      </div>

      <div className="txt-center margin-top-2">
        <NavLink className="link--discreet" to="/tools">
          <Icon name="caret-left" size={16} top={-2} /> All Ooki Tools
        </NavLink>
      </div>
    </section>
  )
}

export default observer(WrapNative)
